export const environment = {
  production: false,
  apiUrl: "https://jf-myapi.presonus.com/publicapi/",
  phpBaseUrl: "https://jf-myapi.presonus.com/",
  mypresonusUrl: "https://jf-my.presonus.com/",
  connectUrl: "https://jf-connect.presonus.com/",
  shopUrl: "https://shopahdev8.presonus.com/",
  uuxUrl: "https://jf-uux.presonus.com/",
  q2aApiUrl: "https://answers.presonus.com/api.php/",
  cloudApiUrl: "https://cloudapidavedev.presonus.com/api/",
  wasabiContentUrl: "https://cloud-userdata-dev-wasabi.presonusmusic.com/",
  awsContentUrl: "https://cloud-userdata-dev.presonusmusic.com/",
  sharedAssetsUrl: "https://cloud-userdata-dev.presonusmusic.com/",
  paeApiUrl: "https://9rtb6srm52.execute-api.us-east-1.amazonaws.com/dev/",
  baseRoutePath: "",
  cookieLocation: ".presonus.com",
  connectCookieLocation: ".fendergarage.com",
  presonusApiKey: "eb8c56f0-c1e4-48df-b988-8ca9b1904076",
  intercom: false,
  intercomAppId: "oos4jm75",
  intercomSDKKeys: {
    ios: "ios_sdk-a3f5624b5847cc5dc4f83a50170f304f68113fee",
    android: "android_sdk-46eec20a87145af04ce7c56fd9e3f1d120d3366b",
  },
  features: {
    exchange: true,
    redeem_ampire_fatchannel: true,
    sphere: true,
    sphere_beta: false,
    new_sphere_onboarding: true,
    metro: true,
    community: true,
    obedia: true,
    public_file_links: false,
    iterable: true,
    bronto: false,
    unified_app: true,
    stripe_subscription: true,
    cookie_management: false,
    active_offers: true,
    bluesnap_to_stripe_migration: true,
    community_search: true,
    use_paeapi: true,
  },
  vimeoAuthToken: "59af0e76212fa6c9e1815021bef66563",
  obediaVimeoAuthToken: "13a1094e8394ebf9249e83a1d51c2809",
  firebase: {
    apiKey: "AIzaSyBu4QUNfLFVScfHT0zoxDRR5G6xyMIQ6PA",
    authDomain: "mypresonus-abd2e.firebaseapp.com",
    databaseURL: "https://mypresonus-abd2e.firebaseio.com",
    projectId: "mypresonus-abd2e",
    storageBucket: "mypresonus-abd2e.appspot.com",
    messagingSenderId: "1062608341650",
    appId: "1:1062608341650:web:285c2b413042d8581b344b",
    vapidKey: "BJ5VYbHeIRIR1HEBQODo1qfbgbhVGxViVP6wpHR-rs6c2ZP9VPwfQy0nHYCkC_aUPm9MvynFRU1QdGhex0mtqKQ",
  },
  avo: {
    on: true,
    apiKey: "lIw4itkgPQqveYcG8oDa",
    connectKey: "DXQsT4oS3HKd2huoGchH",
    logMocks: false,
  },
  usercentricsScriptId: "usercentrics-dev",
  bluesnap: {
    domainPath: "https://sandbox.bluesnap.com",
    scriptID: "bluesnap_hostedfields_sandbox",
    contractIDs: {
      sphere_monthly: 3779474,
      sphere_annual: 3794256,
      sphere_storage_monthly: 3823878,
      sphere_storage_annual: 3823880,
    },
  },
  segment: {
    writeKey: "8Ig1bKvfHHzKpOWs3RvDVH5lpKSykEBQ",
    scriptID: "segment-dev",
  },
  googleMapsKey: "AIzaSyBIbF61F87RCS81MKJK7iorZUgyycP1h-A",
  product_ids: {
    abletonlivelite: 870,
    sphere_monthly: 1054,
    sphere_annual: 1055,
    s16artist: 1531,
    s16pro: 1532,
  },
  algolia: {
    app_id: "CR3MWDT472",
    apiKey: "1592d17776db095821c42f7b2beb4d21",
  },
  stripe: {
    public_key: "pk_test_51LG2XKBg19zdLcFOkiCpRIXPXKMw7aHHoFNvDP0QJutkcN6ITQ2AXwwo6uzv4NPPoL173UdGUEgJkTUxFTiT0HNb00pL9yf5jG",
    subscription_product: { annual: "prod_MTo5D3DACXXkfe", monthly: "prod_LxyZHcTpdewIyu" },
    no_decimal_currencies: ["BIF", "CLP", "DJF", "GNF", "ISK", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"],
    divisible_by_100_currencies: ["UGX", "ISK"],
    replace_currency: [{ from: "HRK", to: "EUR" }],
    test_clock: "clock_1OHrVGBg19zdLcFOFIU6F0CD",
  },
  tax: {
    tax_code: "DC020500",
    customer_code: "PreSonusGuest",
  },
  cognito: {
    userPoolId: "us-east-1_relWD8cqj",
    clientId: "1fc15flemo4nr4rbjqlu0krjcj",
  },
  reCaptchaKey: "6LegoE8UAAAAAPseGMe8jWG9Wmij_UPcWHtZ_RRu",
  bugsnagApiKeyWeb: "aa3900b44fae862e4b2c65bc1681003c",
  bugsnagApiKeyIOS: "5f953ad39e5713500fecb248a73a9ed0",
  bugsnagApiKeyAndroid: "99d1bf10e7147b17ce8c86e51b284933",
  bugsnagReleaseStage: "development",
  developer_email: "jfrier@fender.com",
};
